import { IntegrationSystem, ServiceCodeBySystem, MergedServiceCodes } from '@/shared/types';
import {
  ARSServiceCode,
  BIAServiceCode,
  ERZServiceCode,
  IACServiceCode,
  MSPServiceCode,
  PAYServiceCode,
  RMPCServiceCode,
  RMPServiceCode,
  WNTServiceCode,
} from '@/shared/types/serviceCodes';

export const serviceCodesBySystem: {
  [K in IntegrationSystem]: ServiceCodeBySystem<K>;
} = {
  [IntegrationSystem.ERZ]: ERZServiceCode,
  [IntegrationSystem.IAC]: IACServiceCode,
  [IntegrationSystem.RMP]: RMPServiceCode,
  [IntegrationSystem.MSP]: MSPServiceCode,
  [IntegrationSystem.BIA]: BIAServiceCode,
  [IntegrationSystem.PAY]: PAYServiceCode,
  [IntegrationSystem.ARS]: ARSServiceCode,
  [IntegrationSystem.WNT]: WNTServiceCode,
  [IntegrationSystem.RMPC]: RMPCServiceCode,
};

export const SERVICE_CODES: MergedServiceCodes = Object.values(serviceCodesBySystem).reduce<MergedServiceCodes>(
  (acc, systemServiceCodes) => {
    if (systemServiceCodes === null) return acc;

    return {
      ...acc,
      ...systemServiceCodes,
    };
  },
  {} as MergedServiceCodes,
);

export const ONE_MB = 1024;
export const LEGAL_AGE: number = 18;
export const UNDER_LEGAL_AGE: number = 14;
export const DATE_STRING_SEPARATOR = '-' as const;
export const DATE_STRING_FORMAT: string = ['YYYY', 'MM', 'DD'].join(DATE_STRING_SEPARATOR);

export enum DeliveryType {
  PERSONAL = 'personal',
  COURIER = 'courier',
  ADDRESS = 'address',
}

export enum WarehouseType {
  MOVEABLE_WAREHOUSE = 'Пересувне відділення',
  FIXED_WAREHOUSE = 'Міське відділення',
}

export enum NamesBeforeFieldName {
  previousLastName = 'last_name',
  previousName = 'first_name',
  previousPatronymic = 'middle_name',
}
